import { FieldSectionSubTypeForApi, FieldsObjectTypeForApi } from 'api/fields/fields';
export const SECONDS = 60;
export const MILLI_SECONDS = 1000;
export const ONE_DAY_IN_MINUTES = 24 * 60;
export const queryStaleTime = (minutes = 5)=>minutes * SECONDS * MILLI_SECONDS;
export const tenMinutes = queryStaleTime(10);
export const fiveMinutes = queryStaleTime(5);
export const oneDay = queryStaleTime(ONE_DAY_IN_MINUTES);
export const oneHour = queryStaleTime(60);
export const HOME_QUERY_KEY = [
    'home'
];
export const CSAT_APPROVAL_COUNT = [
    'CSAT_APPROVAL_COUNT'
];
export const ALL_APPROVALS_HOME_QUERY_KEY = [
    'ALL_APPROVALS_HOME'
];
export const ALL_FIELDS_QUERY_KEY = [
    'all-fields'
];
export const KEY_EVENTS_FIELDS_QUERY_KEY = [
    'key-events-fields'
];
export const PROJECT_FIELDS_QUERY_KEY = [
    'project-fields'
];
export const INTERVALS_FIELDS_QUERY_KEY = [
    'intervals-fields'
];
export const COMPANY_FIELDS_QUERY_KEY = [
    'company-fields'
];
export const TASK_FIELDS_QUERY_KEY = [
    'task-fields'
];
export const ALLOCATION_FIELDS_QUERY_KEY = [
    'resource-allocation-fields'
];
export const TIME_ENTRY_QUERY_KEY = [
    'time-entry'
];
export const TIME_ENTRY_FIELDS_QUERY_KEY = [
    'time-entry'
];
export const TEAM_MEMBER_FIELDS_QUERY_KEY = [
    'team-member-fields'
];
export const FINANCIAL_FIELDS_QUERY_KEY = [
    'financial-fields'
];
export const FINANCIAL_BUDGET_FIELDS_QUERY_KEY = [
    'financial-budget-fields'
];
export const PROJECT_STATUS_FIELD_QUERY_KEY = [
    'project-status-field'
];
export const SPRINT_FIELD_QUERY_KEY = [
    'sprint-fields'
];
export const EXPENSE_FIELDS_QUERY_KEY = [
    'expense-fields'
];
export const INVOICE_FIELDS_QUERY_KEY = [
    'invoice-fields'
];
export const CREDIT_NOTE_FIELDS_QUERY_KEY = [
    'credit-note-fields'
];
export const USERS_FIELDS_QUERY_KEY = [
    'users-fields'
];
export const USERS_SKILLS_FIELDS_QUERY_KEY = [
    'users-fields',
    'skills'
];
export const EPIC_FIELDS_QUERY_KEY = [
    'epic-fields'
];
export const BACKLOG_FIELDS_QUERY_KEY = [
    'backlog-fields'
];
export const SHEET_FIELDS_QUERY_KEY = [
    'sheet-fields'
];
export const REPORT_FIELDS_QUERY_KEY = [
    'report-fields'
];
export const TIMEOFF_FIELDS_QUERY_KEY = [
    'timeoff-fields'
];
export const PROJECT_PHASE_FIELDS_QUERY_KEY = [
    'project-phase-fields'
];
export const CUSTOMER_TEAM_MEMBER_FIELDS_QUERY_KEY = [
    'customer-team-member-fields'
];
export const SKILL_FIELDS_FOR_READ_ACCESS_QUERY_KEY = 'skill-fields-for-read';
export const ALL_PROJECTS_QUERY_KEY = [
    'all-projects'
];
export const ALL_EPICS_QUERY_KEY = [
    'all-epics'
];
export const ALL_PROJECTS_RM_QUERY_KEY = [
    'all-projects-rm'
];
export const ARCHIVED_PROJECTS_QUERY_KEY = [
    'archived-projects'
];
export const DELETED_PROJECTS_QUERY_KEY = [
    'deleted-projects'
];
export const PROJECTS_META_QUERY_KEY = [
    'projects-meta'
];
export const ALL_PROJECT_CURRENT_PHASES_QUERY_KEY = [
    'all-project-current-phases'
];
export const ALL_PROJECTS_WITH_MEMBERS_RM_QUERY_KEY = [
    'all-projects-with-members-rm-query-key'
];
export const PROJECT_WITH_MEMBERS_RM_QUERY_KEY = [
    'project-with-members-rm-query-key'
];
export const fieldsQueryKeys = {
    TASK: TASK_FIELDS_QUERY_KEY,
    PROJECT: PROJECT_FIELDS_QUERY_KEY,
    PROJECT_PHASE: PROJECT_PHASE_FIELDS_QUERY_KEY,
    EXPENSE: EXPENSE_FIELDS_QUERY_KEY,
    INVOICE: INVOICE_FIELDS_QUERY_KEY,
    USERS: USERS_FIELDS_QUERY_KEY,
    TIME_ENTRY: TIME_ENTRY_FIELDS_QUERY_KEY,
    RESOURCE_ALLOCATION: ALLOCATION_FIELDS_QUERY_KEY,
    COMPANY: COMPANY_FIELDS_QUERY_KEY,
    SPRINT: SPRINT_FIELD_QUERY_KEY,
    EPIC: EPIC_FIELDS_QUERY_KEY,
    BACKLOG: BACKLOG_FIELDS_QUERY_KEY,
    SHEET: SHEET_FIELDS_QUERY_KEY,
    INTERVALS: INTERVALS_FIELDS_QUERY_KEY,
    KEY_EVENTS: KEY_EVENTS_FIELDS_QUERY_KEY,
    FINANCIAL: FINANCIAL_FIELDS_QUERY_KEY,
    REPORTS: REPORT_FIELDS_QUERY_KEY,
    PROJECT_FINANCIALS_BUDGET: FINANCIAL_BUDGET_FIELDS_QUERY_KEY,
    TIME_OFF: TIMEOFF_FIELDS_QUERY_KEY,
    TIMEOFF: TIMEOFF_FIELDS_QUERY_KEY
};
export const objectSubTypes = {
    DEFAULT: FieldSectionSubTypeForApi.Default,
    SKILL: FieldSectionSubTypeForApi.Skill,
    EXTERNAL_TEAM_MEMBER: FieldSectionSubTypeForApi.ExternalUser,
    CUSTOMER_USER: FieldSectionSubTypeForApi.CustomerUser,
    INVOICE_PROJECT: FieldSectionSubTypeForApi.InvoiceProject
};
export const objectTypes = {
    TASK: FieldsObjectTypeForApi.Tasks,
    PROJECT: FieldsObjectTypeForApi.Projects,
    PROJECT_PHASE: FieldsObjectTypeForApi.ProjectPhase,
    EXPENSE: FieldsObjectTypeForApi.Expense,
    INVOICE: FieldsObjectTypeForApi.Invoice,
    USERS: FieldsObjectTypeForApi.Users,
    TIME_ENTRY: FieldsObjectTypeForApi.TimeEntry,
    RESOURCE_ALLOCATION: FieldsObjectTypeForApi.ResourceAllocation,
    COMPANY: FieldsObjectTypeForApi.Company,
    SPRINT: FieldsObjectTypeForApi.Sprint,
    EPIC: FieldsObjectTypeForApi.Epic,
    BACKLOG: FieldsObjectTypeForApi.Backlog,
    SHEET: FieldsObjectTypeForApi.Sheet,
    INTERVALS: FieldsObjectTypeForApi.Intervals,
    KEY_EVENTS: FieldsObjectTypeForApi.KeyEvents,
    REPORTS: FieldsObjectTypeForApi.Reports,
    FINANCIAL: FieldsObjectTypeForApi.Financial,
    TIME_OFF: FieldsObjectTypeForApi.Timeoff,
    PROJECT_FINANCIALS_BUDGET: FieldsObjectTypeForApi.Budget
};
